<div class="container py-5">
    <h2>Contáctenos</h2>
    <p>Wescot Corporation</p>
    <p>Correo: <a href="mailto:soporte@wescot.com.co">soporte&#64;wescot.com.co</a></p>
    <p>Dirección: Bogotá, Colombia</p>
    <p>Teléfono: +00 61 426 037 898</p>
    <form action="https://www.wescotcorporation.com/subscribe.php" method="post" class="mt-4">
        <div class="input-group" style="max-width: 400px;">
            <input type="email" name="email" class="form-control" placeholder="Tu correo" required>
            <button class="btn btn-primary" type="submit">Enviar</button>
        </div>
    </form>
</div>